<div class="ticket-attribute">
  <div class="new-button">
    <app-button
      (click)="openModal()"
      [icon]="'note_add'"
      [customColor]="'green'"
      [fontSize]="24"
    ></app-button>
  </div>
  <div *ngFor="let item of ticketCategories;" class="ticket-attribute-container">
    <div class="title">
      <div>Név: {{item.name}}</div>
      <app-button
        (click)="openModal(item)"
        [icon]="'edit'"
        [customColor]="'yellow'"
      ></app-button>
      <app-button
        [icon]="'delete'"
        [customColor]="'red'"
        [matMenuTriggerFor]="delMenu"
      ></app-button>
    </div>
    <mat-menu class="menu-for-delete" #delMenu="matMenu" xPosition="before">
      <div class="ticket-delete-title">Biztosan törli?</div>
      <div
        class="ticket-delete-option"
        (click)="del(item)"
      >Igen</div>
      <div
        class="ticket-delete-option"
      >nem</div>
    </mat-menu>
  </div>
</div>
